
define('ldsh!modules/emblue/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="emblue">\n  ';
 if (tab=="savenewcps" ) { };
__p += '\n\n    ';
 if (tab=="createemblueaccount" ) { ;
__p += '\n      ';
 if (migrationStatus===false) { ;
__p += '\n        <div class="spinner__container"></div>\n        <h2 class="i18n" data-i18n="EMBLUE.WELCOME"></h2>\n        <p class="i18n" data-i18n="EMBLUE.CREATING"></p>\n        ';
 } ;
__p += '\n          ';
 if ( migrationStatus==1) { ;
__p += '\n            <div class="error"></div>\n            <h2 class="i18n" data-i18n="EMBLUE.CREATED_ERROR_1"></h2>\n            <p class="i18n" data-i18n="[html]EMBLUE.CREATED_ERROR_2"></p>\n            ';
 } ;
__p += '\n              ';
 if ( migrationStatus==2) { ;
__p += '\n                <div class="account__created"></div>\n                <h2 class="i18n" data-i18n="EMBLUE.WELCOME_CREATED"></h2>\n                <p class="i18n" data-i18n="EMBLUE.CREATED_1"></p>\n                <p class="i18n" data-i18n="EMBLUE.CREATED_2"></p>\n                <p class="i18n" data-i18n="[html]EMBLUE.CREATED_3"></p>\n                ';
 } ;
__p += '\n\n                  ';
 if ( migrationStatus==3) { ;
__p += '\n                    <div class="error"></div>\n                    <h2 class="i18n" data-i18n="EMBLUE.CREATED_ERROR_1"></h2>\n                    <p class="i18n" data-i18n="EMBLUE.CREATED_ERROR_EXIST_1"></p>\n                    <p class="i18n" data-i18n="[html]EMBLUE.CREATED_ERROR_EXIST_2"></p>\n                    ';
 } ;
__p += '\n                      ';
 } ;
__p += '\n\n</div>';

}
return __p
};});

